<template>
    <div class="appDialog esFixed" ref="esFixed">
        <div class="esBody">
            <img src="https://oss.eventnet.cn/H5/CHENGHAO/Lenovo2022/img/msg/5.png">
        </div>
        <!-- <div class="esBtn" @click="esBtn"></div> -->
    </div>
</template>

<script>
export default {
    name: 'Dialog',
    // inject: ['reload'],
    // props: {
    //     linkTo: String
    // },
    data () {
        return {
        };
    },
    computed: {
        esFixed () {
            return this.$refs.esFixed;
        },
    },
    created () {
    },
    mounted () {
        let that = this;
        that.$nextTick(() => {
            that.esFixed.addEventListener('touchmove', function (e) {
                e.preventDefault();
            }, false);
        });

    },
    methods: {
        esBtn () {
            this.$parent.openEpidemic = false;
        }
    },
    watch: {},
};
</script>
<style scoped lang='less'>
.appDialog {
    position: fixed;
    top:0;right:0;bottom:0;left:0;
    z-index: 100;
    width:100%;
    height: 100%;
    background:rgba(0,0,0,.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: all;
    overflow: hidden;
    .esBody{
        width: 630px;
        height: 422px;
        background:url('https://oss.eventnet.cn/H5/CHENGHAO/Lenovo2022/img/msg/4.png') no-repeat;
        background-size:100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 20px;
        img{
            width:468px;height: 195px;
        }
    }
    .esBtn{
        position: relative;
        width: 70px;
        height: 70px;
        border: solid 2px #e6e6e6;
        border-radius: 50%;
        margin-top: 50px;
        &::before,
        &::after{
            content: '';
            position: absolute;
            top:50%;
            left:50%;
            transform: translate(-50%, -50%) rotate(45deg);
            width: 40px;
            height: 3px;
            background-color:#e6e6e6;
        }
        &::after{
            transform: translate(-50%, -50%) rotate(-45deg);
        }
    }
}
</style>
